import React from "react";
import { Box, Button, Flex, Text, Tooltip } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ChakraFAIcon } from "@/components/ui/Icon";

interface Props {
	tabLimit: number;
	classIsActive: boolean;
	onEdit: () => void;
	onEnd: () => void;
	isUpdating: boolean;
}

export function TabLimitPill(props: Props): JSX.Element {
	const { t } = useTranslation();
	return (
		<Flex background="var(--q-brand-primary-700, #3A3879)" rounded={"md"} color={"white"} py={0.5}>
			<Flex alignItems={"center"} ml={3} mr={4} gap={3}>
				<ChakraFAIcon icon={"fa-browsers"} variant="light" />
				<Text fontWeight={"medium"} data-testid="tab-limit-pill-label">
					{t("tabLimitPill.label", { count: props.tabLimit })}
				</Text>
			</Flex>
			<Box borderLeft={"1px solid rgba(255, 255, 255, 0.5)"}></Box>
			<Box>
				<Tooltip label={t("tabLimitPill.editHint")}>
					<Button
						variant={"unstyled"}
						cursor={"pointer"}
						background={"inherit"}
						color={"inherit"}
						onClick={props.onEdit}
						size={"sm"}
						mx={1}
						aria-label={t("tabLimitPill.editHint")}
						data-testid="tab-limit-pill-edit-button"
					>
						<ChakraFAIcon icon={"fa-pencil"} fontSize={"sm"} variant="solid" />
					</Button>
				</Tooltip>
			</Box>
			<Box borderLeft={"1px solid rgba(255, 255, 255, 0.5)"}></Box>
			<Box>
				<Tooltip label={t("tabLimitPill.endHint")}>
					<Button
						variant={"unstyled"}
						cursor={"pointer"}
						background={"inherit"}
						color={"inherit"}
						onClick={props.onEnd}
						size={"sm"}
						ml={1}
						isDisabled={props.isUpdating}
						_disabled={{ cursor: "not-allowed", background: "inherit", color: "inherit" }}
						aria-label={t("tabLimitPill.endHint")}
						data-testid="tab-limit-pill-end-button"
					>
						<ChakraFAIcon icon={"fa-times"} />
					</Button>
				</Tooltip>
			</Box>
		</Flex>
	);
}
